<template>
  <v-container fluid py-1>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-progress-circular
            v-if="loading || loadingTour"
            :size="30"
            :width="3"
            color="primary"
            indeterminate
          />
          <v-toolbar card flat dense color="white">
            <v-spacer />
            <meta-button type="new" @click="dialog = true" />
          </v-toolbar>
          <template v-if="localPhases.length">
            <v-divider />
            <v-card-text class="pa-0">
              <div class="v-table__overflow">
                <table
                  class="text-xs-center v-datatable v-table theme--light"
                  style="width: 100%"
                >
                  <thead>
                    <tr>
                      <th>{{ $t('fields.global.actions') }}</th>
                      <th>{{ $t('fields.global.order') }}</th>
                      <th>{{ $t('fields.global.state') }}</th>
                      <th>{{ $t('fields.global.name') }}</th>
                      <th>{{ $t('titles.tournaments.ifShowResults') }}</th>
                      <th>{{ $t('titles.tournaments.ifRandomMatches') }}</th>
                      <th>{{ $t('fields.phases.typePlayOff') }}</th>
                      <th>{{ $t('fields.phases.toClass') }}</th>
                      <th>{{ $t('fields.phases.matchesByParticipant') }}</th>
                      <th>{{ $t('fields.tournaments.hours') }}</th>
                    </tr>
                  </thead>
                  <!-- <tbody> -->
                  <draggable
                    v-model="localPhases"
                    tag="tbody"
                    :handle="handler"
                    :class="{ draggable: handler !== 'none' }"
                    @end="dragEnd"
                  >
                    <tr v-for="(phase, index) in localPhases" :key="index + 20">
                      <td class="handle">
                        <v-icon
                          color="success"
                          class="mr-1"
                          @click="setOne(phase._id)"
                        >
                          edit
                        </v-icon>
                        <v-icon color="error" @click="ifDelete(phase._id)">
                          delete
                        </v-icon>
                      </td>
                      <td class="py-2">
                        {{ phase.order }}
                      </td>
                      <td>
                        <button-state :state="phase.active" />
                      </td>
                      <td>{{ getName(phase.name) }}</td>
                      <td>
                        <button-state :state="phase.showResults" />
                      </td>
                      <td>
                        <button-state :state="phase.randomMatches" />
                      </td>
                      <td>
                        {{
                          phase.typePlayOff
                            ? $t(`titles.phases.${phase.typePlayOff}`)
                            : ''
                        }}
                      </td>
                      <td>
                        {{
                          phase.typePlayOff === 'ranking' ? phase.toClass : '-'
                        }}
                      </td>
                      <td>
                        {{
                          phase.typePlayOff === 'ranking'
                            ? phase.matchesByParticipant
                            : '-'
                        }}
                      </td>
                      <td>
                        <template v-for="(hour, index) in phase.hours">
                          <v-chip
                            :key="index + hour"
                            small
                            color="primary"
                            dark
                          >
                            {{ hour }}
                          </v-chip>
                        </template>
                      </td>

                      <hr />
                    </tr>
                  </draggable>

                  <!-- </tbody> -->
                </table>
              </div>
            </v-card-text>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
    <dialog-phase
      ref="form"
      :dialog.sync="dialog"
      :phase.sync="phase"
      :type="type"
      :max-to-class="tournament.numberParticipants || 1"
      :loading="loading"
      @submit="submit"
    />
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import { mapActions, mapState } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import DialogPhase from '@/components/widgets/dialog/DialogPhase'
import { parseObject } from '@/helpers/utils'

export default {
  name: 'TabPhases',
  components: {
    draggable,
    DialogDelete,
    DialogPhase,
  },
  props: {
    phases: {
      type: Array,
      required: true,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      localPhases: [],
      phase: {},
      idDelete: '',
      dialog: false,
      dialogDelete: false,
    }
  },
  watch: {
    selected: {
      handler: function (val) {
        this.phase = parseObject(val)
        this.phase.name = this.selected.name
        if (!this.phase._id) this.phase.toClass = this.toClass
      },
      immediate: true,
      deep: true,
    },
    tournament: {
      handler: function (val) {
        let phases = (val.phases || []).map((phase) => ({
          ...parseObject(phase),
          name: phase.name,
        }))
        this.localPhases = Array.from(phases)
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.phase = parseObject(this.selected)
    this.phase.name = this.selected.name
    if (!this.phase._id) this.phase.toClass = this.toClass
  },
  computed: {
    ...mapState({
      selected: (state) => state.phases.selected,
      loading: (state) => state.phases.loading,
      loadingTour: (state) => state.tournaments.loading,
      tournamentId: (state) => state.tournaments.idSelected,
      tournament: (state) => state.tournaments.selected,
    }),
    toClass() {
      if (this.tournament.numberParticipants) {
        return Math.round(this.tournament.numberParticipants / 2)
      } else return 1
    },
    handler() {
      if (
        this.loading ||
        this.loadingTour ||
        this.localPhases.length <= 1 ||
        !this.can('edit', 'tournament', this.tournament)
      )
        return 'none'
      else if (this.isMobile) return '.handle'
      else return ''
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'phases/fetchOne',
      setCreate: 'phases/create',
      setUpdate: 'phases/update',
      setDelete: 'phases/delete',
      setUpdateTournament: 'tournaments/update',
    }),
    submit() {
      let payload = Object.assign({}, this.phase)
      if (!payload._id) {
        let maxOrder = 0
        this.localPhases.forEach((phase) => {
          if (phase.order > maxOrder) maxOrder = phase.order
        })
        payload.order = maxOrder + 1
        this.setCreate(payload).then((_) => {
          this.$refs.form.cancel()
        })
      } else {
        this.setUpdate(payload).then((_) => {
          this.$refs.form.cancel()
        })
      }
    },
    setOne(id) {
      this.fetchOne(id).then((_) => {
        this.$nextTick((_) => {
          this.dialog = true
        })
      })
    },
    _setDelete(phaseId) {
      this.setDelete(phaseId).then((_) => {
        this.dialogDelete = false
      })
    },
    dragEnd() {
      if (!this.can('edit', 'tournament', this.tournament)) return

      if (this.loading || this.loadingTour || this.localPhases.length < 2)
        return

      let phases = this.localPhases.map((phase, index) => ({
        ...parseObject(phase),
        order: index + 1,
      }))

      let payload = {
        _id: this.tournamentId,
        phases,
      }
      this.setUpdateTournament(payload).then((item) => {
        this.$store.dispatch('tournaments/fetchOne', item._id)
      })
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
  },
}
</script>
